import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
export function ClosingSection() {
  return <section className="section wash closing" aria-labelledby="closing-heading" data-id="element-23" data-mp="ounb6xmzo6p8">
      <div className="shell" data-id="element-24" data-mp="12twtc2ur9avu">
        <p className="eyebrow" data-id="element-25" data-mp="12qr0ccj09ouu">YOUR NEXT SESSION</p>
        <h2 id="closing-heading" data-id="element-26" data-mp="xthdn4n03rap">
          Your next 10 training sessions.
          <br data-id="element-27" data-mp="1cqrn68g32n3s" />
          <span data-id="element-28" data-mp="1cqhz4qelmq0q">Already planned.</span>
        </h2>
        <p data-id="element-29" data-mp="1cox12qt2soy4">
          Ten workshops with facilitator wording, realistic cases and observation sheets — so your
          preparation is reading and printing, not writing from scratch.
        </p>
        <CtaButton href="#offer-details" data-id="element-30" data-mp="1lijx8i173u7u">
          See the complete plan — $27 <ArrowRightIcon size={19} aria-hidden="true" data-id="element-31" data-mp="1hj19lehzp51b" />
        </CtaButton>
        <p className="cta-note" data-id="element-32" data-mp="1vgzmsgkkqvf8">USD · One-time payment · English-language PDFs</p>
      </div>
    </section>;
}